import { get, writable } from 'svelte/store';
import { doc, collection, onSnapshot, query, where, updateDoc, serverTimestamp, addDoc, deleteDoc, orderBy, arrayUnion, arrayRemove } from "firebase/firestore";
import { db } from "./firestore";
import { user, business } from "./auth"

const cardSettingsRef = collection(db, "cardSettings");

export function test() {
    console.log("test");
    let _user = get(user);
    let _business = get(business);
    console.log(_user, _business);
}

export function addCard(card) {
    console.log(e.detail);
    let _business = get(business);
    let _user = get(user);
    addDoc(cardSettingsRef, {
        name: card.name,
        stampCount: card.stampCount,
        businesses: [_business.id],
        created: serverTimestamp(),
        owner: _user.uid,
        published: false,
        archived: false,
    });
}

export function archiveCard(id) {
    console.log("archiveCard");
    let _business = get(business);
    const cardRef = doc(db, "cardSettings", id);
    updateDoc(cardRef, {
        archived: true
    });
    let businessRef = doc(db, "businesses", _business.id);
    updateDoc(businessRef, {cardSettings: arrayRemove(id)});
}
    
export function removeCard(id) {
    let _business = get(business);
    const cardRef = doc(db, "cardSettings", id);
    deleteDoc(cardRef);
    let businessRef = doc(db, "businesses", _business.id);
    updateDoc(businessRef, {cardSettings: arrayRemove(id)});
}

export function publishCard(id) {
    let _business = get(business);
    const cardRef = doc(db, "cardSettings", id);
    updateDoc(cardRef, {
        published: true,
    });
    // active.forEach((card) => {
    //     const cardRef = doc(db, "cardSettings", card.id);
    //     updateDoc(cardRef, {
    //         archived: true
    //     });
    //     let businessRef = doc(db, "businesses", _business.id);
    //     updateDoc(businessRef, {cardSettings: arrayRemove(card.id)});
    // })
    let businessRef = doc(db, "businesses", _business.id);
    updateDoc(businessRef, {cardSettings: arrayUnion(id)});
}